export enum UserRole {
  MASTER_ADMIN = 'MASTER',
  RECEPTIONIST = 'RECEPTION',
}

export enum MeetingStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CONFIRMED = 'CONFIRMED',
}

export enum NotificationType {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export enum NotificationStatus {
  SENT = 'SENT',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export interface User {
  id: string;
  fullName: string;
  email: string;
  phone?: string;
  role: UserRole;
  isActive: boolean;
  createdAt: string;
}

export interface WorkSchedule {
  id: string;
  adminId: string;
  workDate: string;
  startTime: string;
  endTime: string;
  breakStart?: string;
  breakEnd?: string;
  maxMeetingsPerSlot: number;
  isAvailable: boolean;
  createdAt: string;
}

export interface Meeting {
  id: string;
  receptionistId: string;
  scheduleId: string;
  visitorName: string;
  visitorCompany?: string;
  visitorPhone: string;
  visitorEmail: string;
  meetingPurpose: string;
  meetingDate: string;
  meetingTime: string;
  status: MeetingStatus;
  adminRemarks?: string;
  approvedBy?: string;
  approvedAt?: string;
  createdAt: string;
  updatedAt: string;
  notificationLogs?: NotificationLog[];
}

export interface NotificationLog {
  id: string;
  meetingId?: string;
  type: NotificationType;
  recipient: string;
  status: NotificationStatus;
  response?: string;
  sentAt: string;
  meeting?: Meeting;
}

export interface AvailableSlotInfo {
  time: string;
  available: boolean;
  bookedCount: number;
  maxCapacity: number;
}

export interface DashboardAnalytics {
  todayTotalMeetings: number;
  pendingApprovals: number;
  confirmedMeetings: number;
  rejectedMeetings: number;
  upcomingMeetingsCount: number;
  scheduleUtilizationPercent: number;
  statusBreakdown: { name: string; count: number; color: string }[];
}
